// accessibility, focus trap to prevent focus from returning to the page.
import { createFocusTrap } from 'focus-trap';
import Logger from './logger';

function FocusTrap() {
  let attempt = 1;
  let wrapperTrap;
  const intervals = [];

  const focusTrapConfig = {
    allowOutsideClick: true,
  };

  const clearIntervals = (intervalFuncs) => {
    attempt = 1;
    intervalFuncs.forEach(
      (interval) => clearInterval(interval)
    );
  };

  const focusTrap = (query, config = {}) => {
    const trapConfig = { ...focusTrapConfig, ...config };
    intervals.push(
      setInterval(
        () => {
          if (attempt % 8 === 0) { clearIntervals(intervals); return; }
          const wrapper = document.querySelector(query);
          attempt += 1;
          if (!wrapper) { return; }
          try {
            wrapperTrap = createFocusTrap(
              wrapper,
              trapConfig
            );
            wrapperTrap.activate();
            clearIntervals(intervals);
          } catch {
            Logger.error('Not able to activate focus trap.');
          }
        }, 1000
      )
    );
  };

  const focusPage = (query = '.page-wrapper') => {
    clearIntervals(intervals);
    focusTrap(query);
  };

  const focusModal = (query, config = {}) => {
    clearIntervals(intervals);

    if (query && typeof query === 'string') focusTrap(query, config);
    else focusTrap('.ReactModal__Content', config);
  };

  const focusRemove = () => {
    if (wrapperTrap) wrapperTrap.deactivate();
  };

  return {
    clearIntervals,
    focusPage,
    focusModal,
    focusRemove,
  };
}

const focusTrap = new FocusTrap();

export default focusTrap;
